import React from "react";
import { Zap, Database, Globe, GraduationCap, ShieldCheck } from "lucide-react";
import { expertiseDomains } from "../data/mockData";

const categoryIcons = {
  "Traitement automatisé": Zap,
  "Bases de données": Database,
  "Diffusion web": Globe,
  Formation: GraduationCap,
};

export const Expertise = () => (
  <section id="expertise" className="section section-alt">
    <div className="shell">
      <div className="mx-auto max-w-[840px] text-center">
        <h2 className="h2">
          Les outils que nous pratiquons <em>au quotidien</em>
        </h2>
        <p className="lede mt-6">
          Une pile technique choisie pour rester lisible et maintenable par vos
          équipes après notre intervention.
        </p>
      </div>

      <div className="mt-10 lg:mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {expertiseDomains.map((domain) => {
          const Icon = categoryIcons[domain.category] || Zap;
          return (
            <div key={domain.category} className="card">
              <Icon className="card-ico" strokeWidth={1.8} aria-hidden="true" />
              <h3 className="text-vt-h3 font-bold text-brand">
                {domain.category}
              </h3>
              <ul className="mt-5 flex flex-wrap gap-2">
                {domain.skills.map((skill) => (
                  <li key={skill} className="tag">
                    {skill}
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>

      <div className="mt-8 flex flex-col items-start gap-6 rounded-[20px] border border-border bg-white p-8 sm:flex-row sm:items-center lg:p-10">
        <ShieldCheck
          className="h-9 w-9 flex-none text-accent"
          strokeWidth={1.8}
          aria-hidden="true"
        />
        <div>
          <p className="font-display text-vt-h3 font-bold leading-snug text-brand">
            Un traitement n'est utile que s'il tourne encore dans six mois, sans
            nous.
          </p>
          <p className="mt-2 leading-relaxed text-t2">
            Chaque mandat est livré avec sa documentation, ses scripts
            versionnés et une séance de transfert, pour que vos équipes
            reprennent la main.
          </p>
        </div>
      </div>
    </div>
  </section>
);
